import { render, staticRenderFns } from "./HeaderColapseTableNegotiation.vue?vue&type=template&id=51e7d409&scoped=true"
import script from "./HeaderColapseTableNegotiation.vue?vue&type=script&lang=js"
export * from "./HeaderColapseTableNegotiation.vue?vue&type=script&lang=js"
import style0 from "./HeaderColapseTableNegotiation.vue?vue&type=style&index=0&id=51e7d409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7d409",
  null
  
)

export default component.exports